import { SharedAppConstants } from '@tock/shared-app-constants';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function dismiss(version: any): BaseTockAction {
  return {
    type: SharedAppConstants.ANNOUNCEMENTS_SET_UPDATE_SEEN,
    payload: version,
  };
}

export function showEventsUpgradeNag(): BaseTockAction {
  return {
    type: SharedAppConstants.ANNOUNCEMENTS_SHOW_EVENTS_UPGRADE_NAG,
  };
}
